import React from "react";
import {withRouter} from "react-router";
import Framework from "@beardeddevops/react.framework";
import API from "@beardeddevops/react.api";
import Types from 'constants/Types';
import {Button} from "reactstrap";
import moment from "moment";
import {confirmAlert} from "react-confirm-alert";

class AccountIntegrations extends Framework.Components.Object {

	constructor(props) {
		super(props, Types.Accounts_Customizations._name);
		this.noDelete = false;
		this.state.rangeManagerBilling = null;
		this.state.rangeManagerBillingLoading = true;
		this.state.rangeManagerBillingError = false;
		this.state.rangeManagerSubscribing = false;
		this.state.rangeManagerUnsubscribing = false;
	}

	loadSelfAfter() {
		this.loadRangeManagerBilling().then();
	}

	loadRangeManagerBilling = async () => {
		this.setState({rangeManagerBillingLoading: true, rangeManagerBillingError: false});
		try {
			const billing = new API.BuildClass(Types.Accounts_Billing._name, API.RequestType.READ);
			const rangeManagerBilling = await billing.submit(null, 'GET_RANGE_MANAGER');
			if (!rangeManagerBilling || typeof rangeManagerBilling.active !== 'boolean') {
				throw new Error('Unable to verify Range Manager subscription status.');
			}
			this.setState({rangeManagerBilling, rangeManagerBillingLoading: false});
			this.props.rootState.set({has_range_manager: !!rangeManagerBilling.active});
		} catch (error) {
			this.setState({rangeManagerBilling: null, rangeManagerBillingLoading: false, rangeManagerBillingError: true});
		}
	}

	subscribeRangeManager = async () => {
		if (this.state.rangeManagerSubscribing) {
			return;
		}

		this.setState({rangeManagerSubscribing: true});
		try {
			const billing = new API.BuildClass(Types.Accounts_Billing._name, 'POST_RANGE_MANAGER');
			const rangeManagerBilling = await billing.submit(null, 'POST_RANGE_MANAGER');
			this.setState({rangeManagerBilling, rangeManagerSubscribing: false});
			this.props.rootState.set({has_range_manager: !!rangeManagerBilling.active});
			API.Toast.success('Range Manager is now active on your account.');
			window.location.reload();
		} catch (error) {
			this.setState({rangeManagerSubscribing: false});
		}
	}

	unsubscribeRangeManager = async () => {
		if (this.state.rangeManagerUnsubscribing) {
			return;
		}

		this.setState({rangeManagerUnsubscribing: true});
		try {
			const billing = new API.BuildClass(Types.Accounts_Billing._name, API.RequestType.DELETE);
			const rangeManagerBilling = await billing.submit(null, 'DELETE_RANGE_MANAGER');
			if (!rangeManagerBilling || rangeManagerBilling.active !== false) {
				throw new Error('Range Manager cancellation was not confirmed.');
			}
			this.setState({rangeManagerBilling, rangeManagerUnsubscribing: false});
			this.props.rootState.set({has_range_manager: !!rangeManagerBilling.active});
			API.Toast.success('Range Manager has been unsubscribed from this account.');
			window.location.reload();
		} catch (error) {
			this.setState({rangeManagerUnsubscribing: false});
		}
	}

	confirmRangeManagerSubscription = () => {
		confirmAlert({
			title: 'Subscribe to Range Manager',
			message: 'Your card on file will be charged $100.00 now and $100.00 each month until canceled.',
			buttons: [
				{
					label: 'Subscribe',
					onClick: this.subscribeRangeManager,
				},
				{
					label: 'Cancel',
				},
			],
		});
	}

	confirmRangeManagerUnsubscription = () => {
		confirmAlert({
			title: 'Unsubscribe from Range Manager',
			message: 'Are you sure you want to unsubscribe from Range Manager?',
			buttons: [
				{
					label: 'Unsubscribe',
					onClick: this.unsubscribeRangeManager,
				},
				{
					label: 'Cancel',
				},
			],
		});
	}

	afterSubmit = () => {
		//reload the tab
		window.location.reload();
	}

	enableAmmoReady = async () => {
		//call the api to enable it, and then refresh
		this.state.ammoready_enabled = true;
		// await this.setState({ammoready_enabled: true});
		await super.handleSubmit();
	}

	form = () => {
		/**
		 *  @param {Accounts_Customizations_Properties} data
		 */
		let {properties} = this.model;
		/**
		 *  @type {Accounts_Customizations_Object} object
		 */
		let object = this.state;

		const originator = object.ammoready_synctype ? 'POS' : 'AmmoReady';
		const destination = object.ammoready_synctype ? 'AmmoReady' : 'POS';
		const {rangeManagerBilling, rangeManagerBillingLoading, rangeManagerBillingError, rangeManagerSubscribing, rangeManagerUnsubscribing} = this.state;
		const rangeManagerRenewalDate = rangeManagerBilling && rangeManagerBilling.renewal_date
			? moment.unix(rangeManagerBilling.renewal_date).format('MM/DD/YYYY')
			: null;
		return (
			<div className={'form-group'}>
				<div className={'row'}>
					<div className={'col-6'}>
						<div>
							<h4 className="section-title">AmmoReady Integration</h4>
							<form>
								<fieldset>
									{this.state.ammoready_enabled ?
										<div>
											<div className="form-group">
												<Framework.Elements.TextField
													name={"username"}
													label={"AmmoReady Username"}
													property={properties.ammoready_username}
													value={object.ammoready_username}
													error={object.ammoready_username_error}
													update={this.handleTextFieldPropertyUpdate}
												/>
											</div>
											<div className="form-group">
												<Framework.Elements.TextField
													name={"password"}
													label={"AmmoReady Password"}
													property={properties.ammoready_password}
													value={object.ammoready_password}
													error={object.ammoready_password_error}
													update={this.handleTextFieldPropertyUpdate}
													type={'password'}
												/>
											</div>
											<div className={'row'} style={{display: 'flex', justifyContent: 'space-between'}}>
												<div className={'col-6'}>
													{this.state.showApiKey ?
														<span>
															<Button className="primary-button"
																style={{marginRight: '10px'}}
																onClick={() => this.setState({showApiKey: false})}>Hide API Key
															</Button>
															{this.state.ammoready_apikey}
														</span>


														: <Button
															color="warning"
															onClick={() => this.setState({showApiKey: true})}>Show API Key
														</Button>}
												</div>
												<div className={'col-6'} style={{display: 'flex', justifyContent: 'end', flexDirection: 'column'}}>
													{/*<Tooltip title={'Which inventory is treated as always correct.'}>*/}
														<div className={'form-group'}>
															<Framework.Elements.ButtonSwitch
																value={!!object.ammoready_synctype}
																error={object.ammoready_synctype_error}
																property={properties.ammoready_synctype}
																update={this.handleTextFieldPropertyUpdate}
																labelTrue={"POS to AmmoReady"}
																labelFalse={"AmmoReady to POS"}
																project={'pos'}
															/>
														</div>
													{/*</Tooltip>*/}
													<div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
														<b style={{textAlign: 'center'}}>
															For all linked products, {originator} will overwrite all {destination} inventory quantities to what exists inside the {originator} inventory.
														</b>
													</div>
												</div>

											</div>
										</div> :
										<div>
											<Button className="primary-button"
												onClick={() => this.enableAmmoReady()}>Enable AmmoReady Integration
											</Button>
										</div>
									}
								</fieldset>
							</form>
						</div>
					</div>
					<div className={'col-6'}>
						{!this.props.rootState.invoicing_enabled &&
							<p className="text-muted" style={{marginTop: "1.5rem"}}>
								Enable local invoicing under Settings → Customizations before configuring AltruPay pay-by-link.
							</p>
						}
						{this.props.rootState.invoicing_enabled && !this.props.rootState.altrupay_linked &&
							<p className="text-muted" style={{marginTop: "1.5rem"}}>
								Link an AltruPay terminal to enable customer pay-by-link and invoice emails.
							</p>
						}
						{this.props.rootState.invoicing_enabled && this.props.rootState.altrupay_linked ?
							<>
								<h4 className="section-title">Membership Integration</h4>
								<form>
									<fieldset>
										<div className="form-group">
											<Framework.Elements.TextField
												name={"membership_api_key"}
												label={"Membership API Key"}
												property={properties.membership_api_key}
												value={object.membership_api_key ?? ""}
												error={object.membership_api_key_error}
												update={this.handleTextFieldPropertyUpdate}
											/>
										</div>
										<div className="form-group">
											<Framework.Elements.TextField
												name={"membership_secret_key"}
												label={"Membership Secret Key"}
												property={properties.membership_secret_key}
												value={object.membership_secret_key ?? ""}
												error={object.membership_secret_key_error}
												update={this.handleTextFieldPropertyUpdate}
												type={'password'}
											/>
										</div>
										<h4 className="section-title" style={{marginTop: "1.5rem"}}>AltruPay Pay-by-Link (email + card)</h4>
										<p className="text-muted" style={{fontSize: "0.9rem"}}>
											Requires local invoicing (Customizations). Sends invoice PDFs by email and lets customers pay by card via a secure link — separate from in-store /invoices cash collection.
										</p>
										<div className="form-group">
											<Framework.Elements.ButtonSwitch
												value={!!object.pay_by_link_enabled}
												error={object.pay_by_link_enabled_error}
												property={properties.pay_by_link_enabled}
												update={this.handleTextFieldPropertyUpdate}
												labelTrue={"AltruPay pay-by-link enabled"}
												labelFalse={"AltruPay pay-by-link disabled"}
												project={'pos'}
											/>
										</div>
										{!!object.pay_by_link_enabled &&
											<div className="form-group">
												<Framework.Elements.ButtonSwitch
													value={!!object.auto_send_invoice_email}
													error={object.auto_send_invoice_email_error}
													property={properties.auto_send_invoice_email}
													update={this.handleTextFieldPropertyUpdate}
													disabled={!object.auto_invoice}
													labelTrue={"Auto-send invoice email on checkout"}
													labelFalse={"Manual send only"}
													project={'pos'}
												/>
												{!object.auto_invoice &&
													<p className="text-muted" style={{fontSize: "0.85rem", marginTop: "0.5rem"}}>
														Enable &quot;Automatically Create Invoice on Checkout&quot; in Customizations to use auto-send.
													</p>
												}
											</div>
										}
									</fieldset>
								</form>
							</>
							: null
						}
					</div>
				</div>
				<div className={'row'} style={{marginTop: '24px'}}>
					<div className={'col-12'}>
						<div style={{border: '1px solid #ddd', borderRadius: '4px', padding: '20px'}}>
							<div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: '24px'}}>
								<div>
									<h4 className="section-title">Range Manager</h4>
									<p>
										Manage live range lanes, bookings, waitlists, operating blocks, and rate plans from BestPOS.
									</p>
									<p style={{marginBottom: 0}}>
										<strong>$100.00 USD per month.</strong> The subscription renews automatically using your card on file.
									</p>
								</div>
								<div style={{minWidth: '240px', textAlign: 'right'}}>
									{rangeManagerBillingLoading ? (
										<span>Loading subscription status...</span>
									) : rangeManagerBillingError ? (
										this.props.rootState.has_range_manager ? (
											<>
												<div><strong>Active</strong></div>
												<Button color="danger" disabled={rangeManagerUnsubscribing} onClick={this.confirmRangeManagerUnsubscription} style={{marginTop: '12px'}}>
													{rangeManagerUnsubscribing ? 'Unsubscribing...' : 'Unsubscribe'}
												</Button>
											</>
										) : null
									) : rangeManagerBilling && rangeManagerBilling.active ? (
										<>
											<div><strong>Active</strong></div>
											{rangeManagerRenewalDate && (
												<div>
													{rangeManagerBilling.cancel_at_period_end ? 'Access ends' : 'Renews'} on {rangeManagerRenewalDate}
												</div>
											)}
											{rangeManagerBilling && rangeManagerBilling.active ? (
												<Button
													color="danger"
													disabled={rangeManagerUnsubscribing}
													onClick={this.confirmRangeManagerUnsubscription}
													style={{marginTop: '12px'}}
												>
													{rangeManagerUnsubscribing ? 'Unsubscribing...' : 'Unsubscribe'}
												</Button>
											) : null}
										</>
									) : (
										<Button
											className='primary-button'
											disabled={rangeManagerSubscribing}
											onClick={this.confirmRangeManagerSubscription}
										>
											{rangeManagerSubscribing ? 'Subscribing...' : 'Subscribe to Range Manager'}
										</Button>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default Framework.Components.withRootState(withRouter(AccountIntegrations));
